import ModalDelete from 'components/ModalDelete'
import * as React from 'react'
import { I18n } from 'react-redux-i18n'
import { useDispatch, useSelector } from 'react-redux'

import { addNewBrand, updateBrand } from '../../../redux/actions/brands'
import ModalWrapper from '../../ChannelView/ModalWrapper'

import './styles.scss'
import { lang } from 'utils/helpers'

const body = (props) => (
  <div className='modal-brand'>
    <div className='input-label'>{lang('dashboard_brand-name')}</div>
    <input className='name-input' defaultValue={props.brandName} onChange={(e) => props.setBrandName(e.target.value)} />
    <div className='buttons-container'>
      <div className='save-button' onClick={props.mainAction}>{props.currentBrand._id ? lang('dashboard_save') : lang('dashboard_add')}</div>
      <div className='cancel-button' onClick={props.toggle}>{lang('dashboard_cancel')}</div>
    </div>
  </div>
)

const ModalBrand = (props) => {
  const [ isSubmitting, setIsSubmitting ] = React.useState(false)
  const [brandName, setBrandName] = React.useState(props.currentBrand.name)

  const dispatch = useDispatch()
  const companies = useSelector(state => state.companies)

  const saveBrand = () => {
    if (isSubmitting) return null
    setIsSubmitting(true)

    dispatch(updateBrand({ ...props.currentBrand, name: brandName }))
      .then(() => {
        props.toggle()
        props.getCompany()
        setIsSubmitting(false)
      })
      .catch(() => {
        setIsSubmitting(false)
      })
  }

  const addBrand = () => {
    if (isSubmitting) return null
    setIsSubmitting(true)

    dispatch(addNewBrand({ name: brandName, idCompany: companies._id }))
      .then(() => {
        props.toggle()
        props.getCompany()
        setIsSubmitting(false)
      })
      .catch(() => {
        setIsSubmitting(false)
      })
  }
  return (
    props.currentBrand.forRemove ?
      <ModalDelete
        isOpen={props.isOpen}
        toggle={props.toggle}
        header={I18n.t('company_remove_brand')}
        text1={I18n.t('company_remove_brand_title')}
        text2={`${I18n.t('company_remove_brand_legend')}<br/><strong>${props.currentBrand.name}</strong>`}
        event={async ()=>{setIsSubmitting(true); await props.removeBrand(props.currentBrand); setIsSubmitting(false)}}
        isSubmitting={isSubmitting}
      />
      :
      <ModalWrapper
        id={'modalBrand'}
        header={props.currentBrand._id ? <h1>{lang('dashboard_edit-brand')}</h1> : <h1>{lang('dashboard_add-brand')}</h1>}
        body={
          body({
            ...props,
            mainAction: props.currentBrand._id ? saveBrand : addBrand,
            brandName: props.currentBrand.name,
            setBrandName
          })
        }
        isOpen={props.isOpen}
        toggle={props.toggle}
        showClose={true}
      />
  )
}

export default ModalBrand